import { useMemo } from 'react';

import { getBaseStatusInformation } from 'helpers/helpers';

export default function useBaseItemStatus(item: any) {
  return useMemo(() => getBaseStatusInformation(item), [item]);
}
